export const regularExps = {

    // email
    email: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
    password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/,  // 6 caracteres, una mayuscula, una minuscula y un numero
    phoneNumber: /^\d{8}$/, // 8 digitos
    date: /^\d{4}-\d{2}-\d{2}$/, // yyyy-mm-dd
    name: /^[a-zA-Z0-9\s\-\.\,]+$/, // letras, numeros, espacios, guiones, comas, y puntos  
}